import React, { FC } from 'react'
import styled from 'styled-components'
import ModalConfirm from 'components/base-ui/ModalConfirm'
import { Fonts, Icon } from 'components/base-ui'
import { useTranslation } from 'react-i18next'
import { LANGUAGES } from 'helpers/language'
export interface DuplicateLineItem {
  productId: number
  productName: string
  quantity: number
}
interface Options {
  title: string
  description: string
  confirm: string
  cancel: string
}

interface ModalConfirmSubmitLineItemProps {
  isOpen: boolean
  onRequestClose: () => void
  isLoading: boolean
  isSubmitting?: boolean
  onAccept: () => void
  onCancel: () => void
  duplicateLineItems: DuplicateLineItem[]
  options: Options
}

const ModalConfirmSubmitLineItem: FC<ModalConfirmSubmitLineItemProps> = ({
  isOpen,
  onRequestClose,
  isLoading,
  isSubmitting,
  onAccept,
  onCancel,
  duplicateLineItems,
  options = {
    title: '',
    description: '',
    confirm: '',
    cancel: '',
  },
}) => {
  const {
    i18n: { language },
    t,
  } = useTranslation()
  const hasDuplicateLineItems = duplicateLineItems.length > 0
  const buttonWidth = language === LANGUAGES.TH ? '85%' : '100%'
  const { title, description, confirm, cancel } = options
  return (
    <ModalConfirm
      testId="submitListItemModalConfirm"
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={true}
      isLoading={isLoading}
      hideCloseButton={false}
      buttonWidth={buttonWidth}
      disableCancelOnProcessing
      btnAccept={{
        outline: false,
        content: confirm,
        onClick: onAccept,
        isProcessing: isSubmitting,
      }}
      btnCancel={{
        outline: true,
        content: cancel,
        onClick: onCancel,
      }}
    >
      <ModalContent>
        {hasDuplicateLineItems ? (
          <>
            <Fonts.H3>
              <Icon name="warning-triangle-redius" style={{ marginRight: 8 }} />
              {t('dineInWarningOrderSubmitted')}
            </Fonts.H3>
            <Fonts.Base>{t('dineInSubmitOrderAgain')}</Fonts.Base>
            <DuplicateItemWrapper>
              {duplicateLineItems.map((lineItem, index) => {
                return (
                  <DuplicateItem key={index}>
                    <Fonts.BaseBold>{`${index + 1}. ${lineItem.productName}`}</Fonts.BaseBold>
                    <Fonts.BaseBold>{`x${lineItem.quantity}`}</Fonts.BaseBold>
                  </DuplicateItem>
                )
              })}
            </DuplicateItemWrapper>
          </>
        ) : (
          <>
            <Fonts.H3 style={{ textAlign: 'center' }}>{title}</Fonts.H3>
            <Fonts.Base style={{ textAlign: 'center' }}>{description}</Fonts.Base>
          </>
        )}
      </ModalContent>
    </ModalConfirm>
  )
}

export default ModalConfirmSubmitLineItem

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 7px;
  padding-bottom: ${({ theme }) => theme.spacing['3XL']};

  .icon-idd-warning-triangle-redius {
    color: #ec7100 !important;
  }
`

const DuplicateItemWrapper = styled.div`
  width: fit-content;
`
const DuplicateItem = styled.div`
  display: flex;
  column-gap: ${({ theme }) => theme.spacing.XS};
  justify-content: space-between;
`
